var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Servic nrk"},[_c('p'),_c('img',{staticClass:"beij",attrs:{"src":"img/zx-6.jpg"}}),_c('img',{staticClass:"beijn",attrs:{"src":"img/zx-14.jpg"}})])
}]

export { render, staticRenderFns }